export default {
    name: "IVEConfig",
    roles: {
        IVE_ADMIN: {
            name: "IVE_ADMIN",
            defaultPath: '/iadmin'
        },
        ADMIN: {
            name: "ADMIN",
            defaultPath: '/admin/testing/dialogs'
        },
        USER: {
            name: "USER",
            defaultPath: '/user'
        },
        USER_CHAT: {
            name: "USER_CHAT",
            defaultPath: '/user/dialogs'
        },
        ADMIN_INNOVATION: {
            name: "ADMIN_INNOVATION",
            defaultPath: '/user/dialogs'
        },
        USER_INNOVATION: {
            name: "USER_INNOVATION",
            defaultPath: '/user/dialogs'
        },
        CUSTOMER_INNOVATION: {
            name: "CUSTOMER_INNOVATION",
            defaultPath: '/iadmin/challengeManagement'
        },
        CUSTOMER_CHAT_INNOVATION: {
            name: "CUSTOMER_CHAT_INNOVATION",
            defaultPath: '/iadmin/challengeManagement'
        },
        APPROVER_INNOVATION: {
            name: "APPROVER_INNOVATION",
            defaultPath: '/approver'
        },
        GHOST_INNOVATION: {
            name: "GHOST_INNOVATION",
            defaultPath: '/oic11/results/challenges'
        },
        RADAR_INNOVATION: {
            name: "RADAR_INNOVATION",
            defaultPath: '/prova'
        },

    },
};
